"use client";

import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const steps = [{
  title: "Safety Audit & Analysis",
  desc: "A comprehensive on-site evaluation of your facility to identify physical hazards and regulatory compliance gaps.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587918/img/blueprint_audit_thumbnail.png"
}, {
  title: "Strategic Planning",
  desc: "Developing a customized safety roadmap that integrates OSHA standards with your specific operational requirements.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587918/img/blueprint_strategy_thumbnail.png"
}, {
  title: "Training & Implementation",
  desc: "Executing safety protocols through specialized workshops and hands-on guidance for your entire workforce.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587918/img/blueprint_implementation_thumbnail.png"
}, {
  title: "Ongoing Compliance",
  desc: "Continuous monitoring and proactive adjustments to maintain a sustainable and effective safety culture.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587918/img/blueprint_growth_thumbnail.png"
}];
export default function TheGrowthBlueprint() {
  const [progress, setProgress] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const startOffset = windowHeight / 2;
      const scrolledPastTop = startOffset - rect.top;
      const totalHeight = rect.height;
      let percentage = scrolledPastTop / totalHeight * 100;
      percentage = Math.max(0, Math.min(100, percentage));
      setProgress(percentage);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="127325" id="your-path-to-compliance" className="bg-background py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        
        {}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tighter text-foreground mb-4 uppercase">
            The Safety Excellence Framework
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-medium">
            A rigorous, four-phase process designed to identify hazards, ensure regulatory compliance, and protect your most valuable assets.
          </p>
        </div>

        {}
        <div className="relative max-w-4xl mx-auto" ref={containerRef}>
          
          {}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px border-l-2 border-dashed border-border md:-translate-x-1/2" />
          
          {}
          <div className="absolute left-8 md:left-1/2 top-0 w-[4px] bg-primary md:-translate-x-1/2 transition-all duration-150 ease-out shadow-[0_0_10px_rgba(249,115,22,0.5)]" style={{
          height: `${progress}%`
        }} />

          {}
          <div className="space-y-16 md:space-y-24">
            {steps.map((step, i) => <div key={i} data-index={i} className="relative flex flex-col md:flex-row items-start md:items-center group">
                
                {}
                <div className="md:hidden pl-24 mb-4 w-full">
                  <h3 className="text-xl font-bold text-foreground tracking-tight uppercase">{step.title}</h3>
                </div>

                {}
                <div className="hidden md:block md:w-[calc(50%-2rem)] text-right pr-8">
                  <h3 className="text-2xl font-extrabold text-foreground tracking-tight uppercase transition-colors duration-300 group-hover:text-primary">
                    {step.title}
                  </h3>
                </div>

                {}
                <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 top-0 md:top-auto flex items-center justify-center w-16 h-16 rounded-full border-4 border-background bg-secondary overflow-hidden z-10 shadow-md transition-transform duration-500 group-hover:scale-110 group-hover:border-primary/40 group-hover:shadow-lg">
                  <img src={step.img} alt={step.title} className="w-full h-full object-cover grayscale opacity-80 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100" />
                </div>

                {}
                <div className="pl-24 md:pl-8 md:w-[calc(50%-2rem)] md:ml-auto">
                  <p className="text-muted-foreground leading-relaxed font-normal">
                    {step.desc}
                  </p>
                </div>
                
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-24 text-center">
          <Button size="lg" className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-lg font-bold uppercase tracking-wider" asChild>
            <Link to="/LetsTalkSafetyPage">Start Your Safety Journey</Link>
          </Button>
        </div>

      </div>
    </section>;
}